import { createApiQuery } from "../../generated-factory";
import { apiClientManager } from "@app/stores/api-manager";
import type { UseGetTemplate1Request, UseGetTemplate1Data, UseGetTemplateList1Request, UseGetTemplateList1Data } from "@api/@types/activity-template";

export const useGetTemplate1 = createApiQuery<UseGetTemplate1Data, UseGetTemplate1Request>({
  queryKey: (req) => ["getTemplate1", req?.groupId, req?.templateId],
  queryFn: (req) => apiClientManager.apis.activityTemplate.getTemplate1(req as UseGetTemplate1Request),
  extractData: (res) => res.data.data as UseGetTemplate1Data,
  isEnabled: (req) => Boolean(req?.groupId && req?.templateId),
});

export const useGetTemplateList1 = createApiQuery<UseGetTemplateList1Data, UseGetTemplateList1Request>({
  queryKey: (req) => ["getTemplateList1", req?.groupId, req?.includeInactive],
  queryFn: (req) => apiClientManager.apis.activityTemplate.getTemplateList1(req as UseGetTemplateList1Request),
  extractData: (res) => res.data.data as UseGetTemplateList1Data,
  isEnabled: (req) => Boolean(req?.groupId),
});

export type { UseGetTemplate1Request, UseGetTemplate1Data, UseGetTemplateList1Request, UseGetTemplateList1Data } from "@api/@types/activity-template";
